import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#163f92',
        secondary: '#F49600'
      },
      dark: {
        primary: '#163f92',
        secondary: '#F49600'
      }
    }
  }
})
